angular.module('filters')
    .filter('friendName', () => (friend) => {

        if (angular.isUndefined(friend)) {

            return null;

        }
        if (friend.attributes.first_name && friend.attributes.last_name) {

            return `${friend.attributes.first_name} ${friend.attributes.last_name}`;

        } else if (friend.attributes.first_name) {

            return friend.attributes.first_name;

        } else if (friend.attributes.last_name) {

            return friend.attributes.last_name;

        } else if (friend.attributes.email) {

            const firstEmailPart = friend.attributes.email.split('@')[0];

            return firstEmailPart;

        }
        return null;

    });



// WEBPACK FOOTER //
// ./scripts/common/filters/friendName.js